import { render, staticRenderFns } from "./AddFriendDialog.vue?vue&type=template&id=647ce048&scoped=true&"
import script from "./AddFriendDialog.vue?vue&type=script&lang=js&"
export * from "./AddFriendDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddFriendDialog.vue?vue&type=style&index=0&id=647ce048&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ce048",
  null
  
)

export default component.exports